// extracted by mini-css-extract-plugin
export default {"control":"Links_control__iL26G","link":"Links_link__uzlNZ","chevron":"Links_chevron__vPmS4"};